export default __webpack_public_path__ + "dd13027af5bd9c9135f443d137fefd1e.png";